"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFuturesSymbolName = void 0;
function getFuturesSymbolName(symbol) {
    return symbol.replace('_', '');
}
exports.getFuturesSymbolName = getFuturesSymbolName;
